import { render, staticRenderFns } from "./PlanCuentas.vue?vue&type=template&id=08b9c219"
import script from "./PlanCuentas.vue?vue&type=script&lang=js"
export * from "./PlanCuentas.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports